import { Moon, Sun } from 'lucide-react'
import { useTheme } from '@/lib/theme'
import { Button } from '../ui/button'

export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme()
  // Toggle from what is on screen: a saved "system" choice must flip on the first click.
  const isDark = resolvedTheme === 'dark'
  const toggle = () => setTheme(isDark ? 'light' : 'dark')

  return (
    <Button
      variant='ghost'
      size='icon'
      className='rounded-full text-muted-foreground hover:text-foreground'
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      onClick={toggle}
    >
      {isDark ? <Sun className='!h-[18px] !w-[18px]' /> : <Moon className='!h-[18px] !w-[18px]' />}
    </Button>
  )
}

export default ThemeToggle
